import { FC, useEffect, useRef, useState } from 'react'
import { useNavigate, Link } from "react-router-dom";

import {Step1} from './steps/Step1'
import {Step2} from './steps/Step2'
import {Step3} from './steps/Step3'
import {KTSVG} from '../../../../../_metronic/helpers'
import {StepperComponent} from '../../../../../_metronic/assets/ts/components'
import {Formik, Form, FormikValues} from 'formik'
import {createAccountSchemas, ICreateAccount, inits} from './CompanyOnboardHelper'

import {companyOnboarding} from '../../../auth/core/_requests'
import {toAbsoluteUrl} from '../../../../../_metronic/helpers'

import {useAuth} from '../../../auth/core/Auth'
import { StatusErrorMessage } from '../../../../components/widgets';
import { doFormSubmit } from '../../../../components/helpers';

const CompanyOnboard: FC = () => {

  const navigate = useNavigate();
  const {saveAuth} = useAuth();

  const stepperRef = useRef<HTMLDivElement | null>(null)
  const stepper = useRef<StepperComponent | null>(null)
  const [currentSchema, setCurrentSchema] = useState(createAccountSchemas[0])
  const [initValues] = useState<ICreateAccount>(inits)
  const [isSubmitButton, setSubmitButton] = useState(false)
        
  const loadStepper = () => {
    stepper.current = StepperComponent.createInstance(stepperRef.current as HTMLDivElement)
  }

  const prevStep = () => {            
    if (!stepper.current) {
      return
    }
    stepper.current.goPrev()
    setCurrentSchema(createAccountSchemas[stepper.current.currentStepIndex - 1])
    setSubmitButton(stepper.current.currentStepIndex === stepper.current.totalStepsNumber)
  }

  const submitStep = async (values: ICreateAccount, actions: FormikValues) => {
              
    const { setStatus, setSubmitting } = actions;

    setStatus('');

    if (!stepper.current) {
      setSubmitting(false);
      return
    }

    if (stepper.current.currentStepIndex !== stepper.current.totalStepsNumber) {
      // move to next step
      stepper.current.goNext()
      setCurrentSchema(createAccountSchemas[stepper.current.currentStepIndex - 1]);
      setSubmitButton(stepper.current.currentStepIndex === stepper.current.totalStepsNumber);
      setSubmitting(false);
      return;
    }
        
    const payload = {
      companyName: values.companyName,
      overseas: values.companyOverseas,
      address: values.companyAddress,
      website: values.companyWebsite,
      tel: values.companyTelephone,
      fax: values.companyFax,
      applicantName: values.adminName,
      email: values.adminEmail,
      password: values.adminPassword,
      designation: values.adminDesignation,                    
    }   
    
    if (! values.companyOverseas) {
      Object.assign(payload, {uen: values.companyRegistration,});
    }

    await doFormSubmit(companyOnboarding, payload, setStatus, setSubmitting, (res) => {
      if (res?.data) {
        const { id, email, password } = res.data;
        saveAuth({                        
          id: id ? id : -1,
          email,
          password,
          loggedIn: false                            
        })                                            
        navigate("/auth/accountotp");                                                     
      }      
    });
  }

  useEffect(() => {
    if (!stepperRef.current) {
      return
    }
    loadStepper()
  }, [stepperRef])

  return (
  <div>
    <div className="p-6 text-center" style={{marginTop: '-60px'}}>
      <img src={toAbsoluteUrl('/media/brand/Setsco_BrandSig_2D_white.png')} className="h-80px" alt='setsco' />
    </div>  
    <div className='card'>
      <div className="bg-primary fs-6 text-white p-6 text-center rounded-top">
        CERTIFICATION APPLICATION & MANAGEMENT SYSTEM
      </div>
      <div className="text-primary fw-bold fs-1 p-6">
        Create Account
      </div>
      <div className="px-10">                
        <div
          ref={stepperRef}
          className='stepper stepper-links d-flex flex-column'
          id='kt_create_account_stepper'
        >
          <div className='stepper-nav mb-5'>
            <div className='stepper-item current' data-kt-stepper-element='nav'>
              <div className="d-flex flex-row justify-content-start align-items-center gap-2 text-primary fs-1 px-6" style={{marginTop: '-1rem'}}>
                <div className="rounded-circle bg-primary text-white text-center fs-2" style={{width: '2.25rem', height: '2.25rem'}}>
                  1
                </div>
                <span className='stepper-title'>Company Setup</span>
              </div>
            </div>
            <div className='stepper-item' data-kt-stepper-element='nav'>
              <div className="d-flex flex-row justify-content-start align-items-center gap-2 text-primary fs-1 px-6" style={{marginTop: '-1rem'}}>
                <div className="rounded-circle bg-primary text-white text-center fs-2" style={{width: '2.25rem', height: '2.25rem'}}>
                  2
                </div>
                <span className='stepper-title'>Company Admin Setup</span>
              </div>                            
            </div>
            <div className='stepper-item' data-kt-stepper-element='nav'>
              <div className="d-flex flex-row justify-content-start align-items-center gap-2 text-primary fs-1 px-6" style={{marginTop: '-1rem'}}>
                <div className="rounded-circle bg-primary text-white text-center fs-2" style={{width: '2.25rem', height: '2.25rem'}}>
                  3
                </div>
                <span className='stepper-title'>Confirm</span>
              </div>
            </div>
          </div>
          <Formik validationSchema={currentSchema} initialValues={initValues} onSubmit={submitStep}>
            {({isSubmitting, status}) => (                      
            <Form className='mx-auto mw-800px w-100 pt-15 pb-10' id='kt_create_account_form'>
              <div className='current' data-kt-stepper-element='content'>
                  <Step1 />
              </div>
              <div data-kt-stepper-element='content'>
                <Step2 />
              </div>
              <div data-kt-stepper-element='content'>
                <Step3 />
              </div>
              
              <div className="mt-8">
                <StatusErrorMessage status={status} />
              </div>
                                              
              <div className='d-flex flex-stack pt-8'>
                <div className='mr-2'>
                  <button
                    onClick={prevStep}
                    type='button'
                    className='btn btn-lg btn-light-primary me-3'
                    data-kt-stepper-action='previous'
                    disabled={isSubmitting}
                  >
                    <KTSVG path='/media/icons/duotune/arrows/arr063.svg' className='svg-icon-4 me-1' />
                    Back                            
                  </button>
                </div>
                <div>
                  <button 
                    type='submit' 
                    className='btn btn-lg btn-primary me-3'
                    disabled={isSubmitting}
                  >
                    { (!isSubmitting) &&
                    <span className='indicator-label'>
                      {!isSubmitButton && 'Continue'}
                      {isSubmitButton && 'Submit'}
                      <KTSVG path='/media/icons/duotune/arrows/arr064.svg' className='svg-icon-3 ms-2 me-0' />
                    </span>    
                    }                                        
                    {isSubmitting &&
                    <span className='indicator-progress' style={{display: 'block'}}>
                      Please wait...                                            
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                    }                                                                        
                  </button>
                </div>
              </div>
            </Form>
          )}                    
          </Formik>
        </div>
      </div>                  
      <div className="text-center p-4">
        <Link to='/auth/login' className="link-primary">
          Back to Login
        </Link>
      </div>        
    </div>
  </div>
  )
}

export {CompanyOnboard}
